import React from 'react';
import { useCallback } from 'react';
import { Globe, Check } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { Button } from './button';
import { supportedLanguages, type Language } from '../../i18n/config';
import { changeLanguageWithRefresh, getCurrentLanguage } from '../../i18n/utils';

const languageNames: Record<Language, string> = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
};

export const LanguageSelector = (): React.JSX.Element => {
  const [open, setOpen] = React.useState(false);
  const currentLanguage = getCurrentLanguage();

  const handleLanguageChange = useCallback((language: Language) => {
    setOpen(false);
    changeLanguageWithRefresh(language);
  }, []);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex bg-white h-9 w-9 px-0 lg:h-10 lg:w-auto lg:px-4"
        >
          <Globe className="h-4 w-4 lg:mr-2" />
          <span className="hidden lg:inline-block">
            {languageNames[currentLanguage]}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-1" align="end">
        <div className="grid gap-1">
          {supportedLanguages.map((lang) => (
            <Button
              key={lang}
              variant="ghost"
              className="flex w-full items-center justify-between"
              onClick={() => void handleLanguageChange(lang)}
            >
              <span>{languageNames[lang]}</span>
              {currentLanguage === lang && (
                <Check className="h-4 w-4 text-primary" />
              )}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
